import { semantic } from '../theme/tokens';

// Note: rColours' names for warning/cardDecoration/default intentionally
// diverge from COLOURS' (src/styles.js) choices for the same roles — preserved
// as-is rather than reconciled.
export const rColours = /** @type {const} */ ({
  good: semantic.good.name,
  error: semantic.error.name,
  warning: 'amber',
  cardDecoration: 'neutral',
  title: semantic.title.name,
  default: 'blue',
});

export const coloursHex = {
  good: semantic.good.hex,
  error: semantic.error.hex,
  warning: semantic.warning.hex,
  cardDecoration: semantic.cardDecoration.hex,
  title: semantic.title.hex,
  default: semantic.default.hex,
};

export const coloursPrime = {
  good: 'lawngreen',
  error: 'red',
  warning: 'yellow',
  cardDecoration: 'darkgrey',
  title: 'SlateGray',
  default: 'royalblue',
};

export const coloursAquaQuipInstaTouch = [
  { value: 0, label: 'blue' },
  { value: 1, label: 'aqua' },
  { value: 2, label: 'green' },
  { value: 3, label: 'gold' },
  { value: 4, label: 'magenta' },
  { value: 5, label: 'red' },
  { value: 6, label: 'white' },
  { value: 7, label: 'seaside' },
  { value: 8, label: 'slow scroll' },
  { value: 9, label: 'fast scroll' },
  { value: 10, label: 'fireworks' },
  { value: 11, label: 'disco' },
  { value: 12, label: 'flash' },
];

export const coloursAquaQuip = [
  { value: 0, label: 'pure red' },
  { value: 1, label: 'deep orange' },
  { value: 2, label: 'pure green' },
  { value: 3, label: 'emerald' },
  { value: 4, label: 'digital blue' },
  { value: 5, label: 'indigo' },
  { value: 6, label: 'magenta' },
  { value: 7, label: 'yellow' },
  { value: 8, label: 'cyan' },
  { value: 9, label: 'white' },
  { value: 10, label: 'pink' },
  { value: 11, label: 'pastel green' },
  { value: 12, label: 'pastel blue' },
  { value: 13, label: 'mauve' },
  { value: 14, label: 'lime green' },
  { value: 15, label: 'baby blue' },
];

export const coloursAstral = [
  { value: 0, label: 'blue' },
  { value: 1, label: 'magenta' },
  { value: 2, label: 'red' },
  { value: 3, label: 'orange' },
  { value: 4, label: 'green' },
  { value: 5, label: 'aqua' },
  { value: 6, label: 'white' },
  { value: 7, label: 'custom 1' },
  { value: 8, label: 'custom 2' },
  { value: 9, label: 'rainbow' },
  { value: 10, label: 'ocean' },
  { value: 11, label: 'disco' },
];

export const coloursSpaElectrics = [
  { value: 0, label: 'blue' },
  { value: 1, label: 'magenta' },
  { value: 2, label: 'red' },
  { value: 3, label: 'lime' },
  { value: 4, label: 'green' },
  { value: 5, label: 'aqua' },
  { value: 6, label: 'day white' },
  { value: 7, label: 'warm white' },
  { value: 8, label: 'slow blend' },
  { value: 9, label: 'fast change' },
];

export const coloursAquatight = [
  { value: 0, label: 'season transition' },
  { value: 1, label: 'daybreak transition' },
  { value: 2, label: 'neutral white' },
  { value: 3, label: 'rainbow' },
  { value: 4, label: 'river of colours' },
  { value: 5, label: 'disco' },
  { value: 6, label: 'four seasons' },
  { value: 7, label: 'party' },
  { value: 8, label: 'sun white' },
  { value: 9, label: 'red' },
  { value: 10, label: 'lush green' },
  { value: 11, label: 'storm blue' },

  { value: 12, label: 'sky blue' },
  { value: 13, label: 'sunset amber' },
  { value: 14, label: 'violet' },
  { value: 15, label: 'storm transition' },
];

export const coloursSpaElectricsMultiPlus = [
  { value: 0, label: 'blue' },
  { value: 1, label: 'magenta' },
  { value: 2, label: 'red' },
  { value: 3, label: 'lime' },
  { value: 4, label: 'green' },
  { value: 5, label: 'aqua' },
  { value: 6, label: 'white' },
  { value: 7, label: 'oceanic views' },
  { value: 8, label: 'transcendence' },
  { value: 9, label: 'outback' },
  { value: 10, label: 'spring equinox' },
];
export const coloursModLite = [
  { value: 0, label: 'slow' },
  { value: 1, label: 'white' },
  { value: 2, label: 'blue' },
  { value: 3, label: 'green' },
  { value: 4, label: 'red' },
  { value: 5, label: 'amber' },
  { value: 6, label: 'magenta' },
  { value: 7, label: 'fast' },
];
export const coloursJandy = [
  { value: 0, label: 'alpine white' },
  { value: 1, label: 'sky blue' },
  { value: 2, label: 'cobalt blue' },
  { value: 3, label: 'caribbean blue' },
  { value: 4, label: 'spring green' },
  { value: 5, label: 'emerald green' },
  { value: 6, label: 'emerald rose' },
  { value: 7, label: 'magenta' },
  { value: 8, label: 'violet' },
  { value: 9, label: 'slow colour' },
  { value: 10, label: 'fast colour' },
  { value: 11, label: 'america' },
  { value: 12, label: 'fat tuesday' },
  { value: 13, label: 'disco' },
];

export const coloursLEDPro = [
  { value: 0, label: '. white' },
  { value: 1, label: 'sky blue' },
  { value: 2, label: 'cobalt blue' },
  { value: 3, label: 'caribbean blue' },
  { value: 4, label: 'spring green' },
  { value: 5, label: 'emerald green' },
  { value: 6, label: 'emerald rose' },
  { value: 7, label: 'magenta' },
  { value: 8, label: 'violet' },
  { value: 9, label: 'slow colour' },
  { value: 10, label: 'fast colour' },
  { value: 11, label: 'america' },
  { value: 12, label: 'fat tuesday' },
  { value: 13, label: 'disco' },
];

export const coloursAquatightSupa = [
  { value: 0, label: 'green' },
  { value: 1, label: 'blue' },
  { value: 2, label: 'red green' },
  { value: 3, label: 'red blue' },
  { value: 4, label: 'green blue' },
  { value: 5, label: 'rgb' },
  { value: 6, label: 'rgb fade' },
  { value: 7, label: 'green blue fade' },
  { value: 8, label: 'red blue fade' },
  { value: 9, label: 'red green fade' },
  { value: 10, label: 'all fade' },
  { value: 11, label: 'blue fade' },
  { value: 12, label: 'green fade' },
  { value: 13, label: 'red fade' },
  { value: 14, label: 'flash' },
  { value: 15, label: 'fade' },
];

export const coloursWaterCo = [
  { value: 0, label: 'white' },
  { value: 1, label: 'slow colour' },
  { value: 2, label: 'fast colour' },
  { value: 3, label: 'blue' },
  { value: 4, label: 'magenta' },
  { value: 5, label: 'red' },
  { value: 6, label: 'gold' },
  { value: 7, label: 'green' },
  { value: 8, label: 'aqua' },
];

export const coloursPentair = [
  { value: 0, label: 'SAM Mode' },
  { value: 1, label: 'Party Mode' },
  { value: 2, label: 'Romance Mode' },
  { value: 3, label: 'Caribbean Mode' },
  { value: 4, label: 'American Mode' },
  { value: 5, label: 'California Sunset Mode' },
  { value: 6, label: 'Royal Mode' },
  { value: 7, label: 'Blue' },
  { value: 8, label: 'Green' },
  { value: 9, label: 'Red' },
  { value: 10, label: 'White' },
  { value: 11, label: 'Magenta' },
  { value: 12, label: 'Hold' },
  { value: 13, label: 'Recall' },
];

export const coloursSingleColour = [{ value: 0, label: 'Single Colour' }];
